import { render, staticRenderFns } from "./VBalances.vue?vue&type=template&id=d5145552&"
import script from "./VBalances.vue?vue&type=script&lang=js&"
export * from "./VBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports